<div class="content-container">
  <p><b>Medication:</b> {{ order.medName }}</p>
  <p><b>Route:</b> {{ order.route }}</p>
  <p><b>Dosage:</b> {{ order.dosage }}</p>
  <p>
    @if (!order.isPRN) {
    <b>Quantity Given:</b>
    <span>
      {{ order.quantityGiven }} / {{ order.quantity }}
    </span>
    }
  </p>
  <p><b>Type:</b> {{ order.type }}</p>
  @if (! order.isPRN) {
  @for (sched of order.providerOrder2MedSchedule(); track $index) {
  <p> {{ sched }} </p>
  }
  } @else {
  <p> <b>Last given at: </b> {{ order.prnLastGivenTimeString }}
  <p> <b>Dosing Instructions: </b>{{ order.prnDosingInstructions }} </p>
  }
  <p><b>Notes:</b> {{ order.orderNotes }}</p>
</div>

<p-divider type="solid" />
<div class="footer">
  <span>Signed by: {{ order.signature }}</span>
  <button pButton pRipple type="button" class="close-button" (click)="closeDialog()">Close</button>
</div>